export class TravelRemoteActionType {
  static readonly DEPART = new TravelRemoteActionType(
    'traveldepart',
    'TRAVEL-REMOTEACTION.DEPART.PAGE-TITLE',
    'TRAVEL-REMOTEACTION.DEPART.DESCRIPTION',
    'TRAVEL-REMOTEACTION.DEPART.TITLE',
    'TRAVEL-REMOTEACTION.DEPART.RA.LABEL.SHORT',
    'TRAVEL-REMOTEACTION.DEPART.RA.LABEL.LONG'
  );
  static readonly ARRIVE = new TravelRemoteActionType(
    'travelarrive',
    'TRAVEL-REMOTEACTION.ARRIVE.PAGE-TITLE',
    'TRAVEL-REMOTEACTION.ARRIVE.DESCRIPTION',
    'TRAVEL-REMOTEACTION.ARRIVE.TITLE',
    'TRAVEL-REMOTEACTION.ARRIVE.RA.LABEL.SHORT',
    'TRAVEL-REMOTEACTION.ARRIVE.RA.LABEL.LONG'
  );

  // private to disallow creating other instances of this type
  private constructor(
    public readonly endpoint: string,
    public readonly pageTitle: string,
    public readonly descriptionKey: string,
    public readonly titleKey: string,
    public readonly raShortLabel: string,
    public readonly raLongLabel: string
  ) {}
}
